import { removeSharingLinks } from '../actions/publicActions';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import { logUsage } from 'owa-analytics';

export function checkForRemovedLinks(
    linkIdContainer: LinkIdContainer,
    existingLinkIdMap: { [key: string]: boolean }
) {
    let removedLinks: string[] = [];

    linkIdContainer.sharingLinkIds.forEach(id => {
        if (!existingLinkIdMap[id]) {
            removedLinks = removedLinks.concat(id);
        }
    });

    if (removedLinks.length > 0) {
        removeSharingLinks(removedLinks);
        logUsage('AttachmentComposeSPLinkRemove');
    }
}
